goog.provide('el8.tourguide.homeInfoSplash');

goog.require('el8.app.pageLayout');
goog.require('el8.tourguide.InfoSplash');
goog.require('el8.template.tourguide.homeInfoSplash');

/**
 * Displays an overview of practice home's navigational elements.
 */
el8.tourguide.homeInfoSplash = (function() {

    var that = new el8.tourguide.InfoSplash({
        name: 'home',
        contentFn: el8.template.tourguide.homeInfoSplash.content,
        UILayoutFn: function() { return el8.app.pageLayout; }
    });

    var STD_RIGHT_TOP_OFFSET = 75;
    var STD_DIST_BOTTOM = 50;  // standard distance from bottom of page
    var STD_RIGHT_WIDTH_FN = function() {
        return Math.min(
            $('#patient-list-container').width() + 25,
            $(window).width() - $('#refBoardContainer').width() - 20);
    };

    that.addBlock({
        anchorSelector: '#refBoard',
        contentFn: el8.template.tourguide.homeInfoSplash.schedulerBlock,
        heightFn: function($elt) {
            return $(window).height() - STD_DIST_BOTTOM - STD_RIGHT_TOP_OFFSET;
        },
        widthFn: function($elt) {
            return $elt.width() - 50;
        },
        topOffset: function($elt) {
            return STD_RIGHT_TOP_OFFSET - $elt.offset().top;
        },
        leftOffset: 20
    });
    that.addBlock({
        anchorSelector: '#main-toolbar',
        contentFn: el8.template.tourguide.homeInfoSplash.writeSeeBarBlock,
        heightFn: function($elt) {
            return $elt.height() + 5;
        },
        widthFn: STD_RIGHT_WIDTH_FN,
        topOffset: -5,
        leftOffset: 2
    });
    that.addBlock({
        anchorSelector: '#chart-home-patient-search',
        contentFn: el8.template.tourguide.homeInfoSplash.patientSearchBlock,
        heightFn: function($elt) {
            return $elt.height() + 10;
        },
        widthFn: STD_RIGHT_WIDTH_FN,
        topOffset: -5,
        leftOffset: -34
    });
    that.addBlock({
        anchorSelector: '#req-act-tabs',
        contentFn: el8.template.tourguide.homeInfoSplash.reqActQueueBlock,
        heightFn: function($elt) {
            return $(window).height() - STD_DIST_BOTTOM - $elt.offset().top + 55;
        },
        widthFn: STD_RIGHT_WIDTH_FN,
        topOffset: -55,
        leftOffset: -31
    });

    return that;

})();
